const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const APPOINTMENT_TYPES = {
  ONLINE: "ONLINE",
  PHYSICAL: "PHYSICAL",
};

const APPOINTMENT_STATUS = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
  ONGOING: "ONGOING",
};

const USER_TYPES = {
  ADMIN: "ADMIN",
  GUARDIAN: "GUARDIAN",
  PATIENT: "PATIENT",
  GUARDIAN_PATIENT: "GUARDIAN_PATIENT",
  DOCTOR: "DOCTOR",
  PHARMACY: "PHARMACY",
};

const AUTH_PROVIDER = {
  EMAIL_PASSWORD: "EMAIL_PASSWORD",
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
};

const PAYMENT_CATEGORY = {
  APPOINTMENT: "APPOINTMENT",
};

const PHARMACY_ORDER_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  SHIPPING: "SHIPPING",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
};

const APPOINTMENT_PURPOSES = {
  CONSULTING: "CONSULTING",
  REPORT_READING: "REPORT_READING",
};

const TIME_FILTER = {
  ALL: "ALL",
  FUTURE: "UPCOMING",
  PRESENT: "PRESENT",
  PAST: "PAST",
};

const SERVING_AREAS = [
  { label: "Home Visiting", value: "HOME_VISITING" },
  { label: "Online", value: "ONLINE" },
  { label: "Private Clinic", value: "PRIVATE_CLINIC" },
];

const PHARMACY_SERVICE_TYPES = {
  HOME_DELIVERY: "HOME_DELIVERY",
  ON_SIGHT: "ON_SIGHT",
  BOTH: "BOTH",
};

const NOTIFICATION_ACTIONS = {
  APPOINTMENT: "appointment",
  NEXT_APPOINTMENT: "next_appointment",
  CHANGE_TIME: "change_time",
  SUGGEST_TIME: "suggest_time",
  NEW_REVIEW: "new_review",
  NEW_COMMENT: "new_comment",
  PRESCRIPTION: "prescription",
  PHARMACY_ORDER: "pharmacy_order",
};

const CATEGORIES = [
  {
    label: "Gynecologic & Obstetrics",
    value: "Gynecologic & Obstetrics",
  },
  {
    label: "Cardiology",
    value: "Cardiology",
  },
  {
    label: "Ear, Nose & Throat (ENT)",
    value: "Ear, Nose & Throat (ENT)",
  },
  {
    label: "Dietician & Nutritionist",
    value: "Dietician & Nutritionist",
  },
  {
    label: "S.T.D.",
    value: "S.T.D.",
  },
  {
    label: "General Medicine",
    value: "General Medicine",
  },
  {
    label: "Community Medicine",
    value: "Community Medicine",
  },
  {
    label: "Dental",
    value: "Dental",
  },
  {
    label: "Dermatology",
    value: "Dermatology",
  },
  {
    label: "Paediatric",
    value: "Paediatric",
  },
    {
    label: "Psychiatry",
    value: "Psychiatry",
  },
  {
    label: "Sports Medicine",
    value: "Sports Medicine",
  },
  {
    label: "Family Medicine",
    value: "Family Medicine",
  },
  {
    label: "Family Planning, Reproductive & Sexual Health",
    value: "Family Planning, Reproductive & Sexual Health",
  },
  {
    label: "Gastroenterology",
    value: "Gastroenterology",
  },
  {
    label: "Ayurvedic",
    value: "Ayurvedic",
  },
  {
    label: "Cosmetic Medicine",
    value: "Cosmetic Medicine",
  },
    {
    label: "Mental Health",
    value: "Mental Health",
  },
];

const AREAS = [
  "Colombo",
  "Gampaha",
  "Kalutara",
  "Kandy",
  "Matale",
  "Nuwara Eliya",
  "Galle",
  "Matara",
  "Hambantota",
  "Jaffna",
  "Kilinochchi",
  "Mannar",
  "Vavuniya",
  "Mullaitivu",
  "Batticaloa",
  "Ampara",
  "Trincomalee",
  "Kurunegala",
  "Puttalam",
  "Anuradhapura",
  "Polonnaruwa",
  "Badulla",
  "Moneragala",
  "Ratnapura",
  "Kegalle",
];

export {
  days,
  APPOINTMENT_TYPES,
  APPOINTMENT_STATUS,
  AUTH_PROVIDER,
  PHARMACY_ORDER_STATUS,
  PHARMACY_SERVICE_TYPES,
  APPOINTMENT_PURPOSES,
  TIME_FILTER,
  PAYMENT_CATEGORY,
  SERVING_AREAS,
  NOTIFICATION_ACTIONS,
  USER_TYPES,
  CATEGORIES,
  AREAS,
};
